export enum PositionTypeEnum {
  FullTime = 1,
  PartTime = 2,
  Contract = 3
}

export const POSITION_TYPE_ENUM_RECORD: Record<PositionTypeEnum, string> = {
  [PositionTypeEnum.FullTime]: 'Full-Time',
  [PositionTypeEnum.PartTime]: 'Part-Time',
  [PositionTypeEnum.Contract]: 'Contract'
};
